import { render, staticRenderFns } from "./client-bonuses.pug?vue&type=template&id=6401d9f7&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./client-bonuses.scss?vue&type=style&index=0&id=6401d9f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401d9f7",
  null
  
)

export default component.exports